/* eslint-disable spire/export-styles */
import * as styleConstants from "@affinity/constants/StyleConstants";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const titleTextStyle = css`
    ${styleConstants.headerMargins}
    color: ${styleConstants.colours.darkBlue};
    font-size: ${styleHelpers.rem(28)};
    line-height: 1.16;
    @media (min-width: 1280px) {
        font-size: ${styleHelpers.rem(48)};
        line-height: 1.16;
    }
`;

export const TitleWrapper = styled.div`
    padding: 0 0 ${styleHelpers.rem(20)} 0;
    @media (min-width: 768px) {
        padding: 0 0 ${styleHelpers.rem(30)} 0;
    }
    @media (min-width: 1280px) {
        padding: 0 0 ${styleHelpers.rem(40)} 0;
    }

    position: relative;
    padding: ${styleHelpers.rem(22)} 0 ${styleHelpers.rem(22)} 0;
    z-index: 0;
    @media (min-width: 768px) {
        padding: ${styleHelpers.rem(30)} 0 ${styleHelpers.rem(30)} 0;
    }
    @media (min-width: 1280px) {
        padding: ${styleHelpers.rem(40)} 0 ${styleHelpers.rem(40)} 0;
    }
    ::after {
        position: absolute;
        top: 0;
        left: 0;
        margin: 0 calc((100% - 100vw) / 2);
        width: 100vw;
        height: 100%;
        z-index: -1;
        display: block;
        content: "";
        background-color: ${styleConstants.colours.lightBlue};
    }
`;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => (
    <TitleWrapper>
        <Typography css={titleTextStyle} variant="h1" data-test-selector="PageTitle">
            {translate(fields.overrideTitle || pageTitle)}
        </Typography>
    </TitleWrapper>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
    },
};

export default widgetModule;
